import { INPUT_DATA_OBJECT_ROUTES } from './InputDataObjects';
import { DataObjectClone } from '../data-objects/DataObjectClone';
import { DataObjectView } from '@atlas-frontend/sdk';
import { useDataObjectActionHandlers } from '../data-objects/useDataObjectActionHandlers';

export const InputDataObjectClone = () => {
  const { handleSuccess, handleCancel } = useDataObjectActionHandlers(
    'inputDataObjectView'
  );

  return (
    <DataObjectClone
      routes={INPUT_DATA_OBJECT_ROUTES}
      view={DataObjectView.IN}
      onSuccess={handleSuccess}
      onCancel={handleCancel}
    />
  );
};
